export const LEGAL_LINKS = [
    { to: "/kvkk", label: "KVKK Aydınlatma Metni", slug: "kvkk" },
    { to: "/gizlilik-politikasi", label: "Gizlilik Politikası", slug: "gizlilik-politikasi" },
    { to: "/cerez-politikasi", label: "Çerez Politikası", slug: "cerez-politikasi" },
    { to: "/mesafeli-satis-sozlesmesi", label: "Mesafeli Satış Sözleşmesi", slug: "mesafeli-satis-sozlesmesi" },
    { to: "/on-bilgilendirme-formu", label: "Ön Bilgilendirme Formu", slug: "on-bilgilendirme-formu" },
    { to: "/iptal-iade-kosullari", label: "İptal ve İade Koşulları", slug: "iptal-iade-kosullari" },
    { to: "/kullanim-kosullari", label: "Kullanım Koşulları", slug: "kullanim-kosullari" },
    { to: "/kargo-teslimat", label: "Kargo ve Teslimat", slug: "kargo-teslimat" },
    { to: "/iletisim", label: "İletişim" },
];

export const getPageUrl = (p) => (p.builtin ? `/${p.slug}` : `/sayfa/${p.slug}`);

const COMPANY = "ATA Angora Tedarik Platformu";
const ADDRESS = "Çankaya / Ankara";
const EMAIL = "ataangora@gmail.com";
const KVKK_EMAIL = "kvkk@ataangora.com.tr";
const UPDATED = "07 Eylül 2026";

export const LEGAL_CONTENT = {
    kvkk: {
        title: "KVKK Aydınlatma Metni",
        updated: UPDATED,
        sections: [
            { h: "1. Veri Sorumlusu", p: [
                `6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") uyarınca, kişisel verileriniz veri sorumlusu sıfatıyla ${COMPANY} (\"Platform\") tarafından aşağıda açıklanan kapsamda işlenmektedir.`,
                `İletişim: ${ADDRESS} — ${KVKK_EMAIL}`,
            ]},
            { h: "2. İşlenen Kişisel Veriler", p: [
                "Kimlik bilgileri (ad, soyad), iletişim bilgileri (e-posta, telefon, adres), firma bilgileri (firma unvanı, vergi numarası, şehir), işlem bilgileri (sipariş, teklif, sepet ve mesajlaşma kayıtları), kullanım verileri (oturum kayıtları, işlem güvenliği logları) ve talep/şikâyet kayıtları işlenmektedir.",
            ]},
            { h: "3. İşleme Amaçları", p: [
                "Kişisel verileriniz; üyelik ve hesap yönetimi, sipariş/teklif süreçlerinin yürütülmesi, tedarikçi-alıcı eşleştirmesi, sevkiyat ve faturalandırma, müşteri destek hizmetleri, yasal yükümlülüklerin yerine getirilmesi, platform güvenliğinin sağlanması ve hizmet kalitesinin artırılması amaçlarıyla işlenmektedir.",
            ]},
            { h: "4. Hukuki Sebepler", p: [
                "Verileriniz; KVKK m.5/2 uyarınca sözleşmenin kurulması ve ifası, veri sorumlusunun hukuki yükümlülüğü, meşru menfaat ve gerektiğinde açık rıza hukuki sebeplerine dayanılarak işlenmektedir.",
            ]},
            { h: "5. Verilerin Aktarımı", p: [
                "Kişisel verileriniz; siparişin gerektirdiği ölçüde ilgili tedarikçilere, kargo/lojistik firmalarına, ödeme kuruluşlarına ve yetkili kamu kurumlarına, KVKK'nın 8. ve 9. maddelerindeki şartlara uygun olarak aktarılabilir. Veriler yurt içindeki güvenli sunucularda saklanmaktadır.",
            ]},
            { h: "6. Saklama Süresi", p: [
                "Kişisel veriler, işleme amacının gerektirdiği süre ve ilgili mevzuatta öngörülen zamanaşımı süreleri boyunca saklanır; süre sonunda silinir, yok edilir veya anonim hale getirilir.",
            ]},
            { h: "7. Haklarınız (KVKK m.11)", p: [
                `Kişisel verilerinize ilişkin erişim, düzeltme, silme, işlemeye itiraz ve aktarım bilgisi talep etme haklarınızı ${KVKK_EMAIL} adresine yazarak kullanabilirsiniz. Başvurular en geç 30 gün içinde yanıtlanır.`,
            ]},
        ],
    },
    "gizlilik-politikasi": {
        title: "Gizlilik Politikası",
        updated: UPDATED,
        sections: [
            { h: "1. Kapsam", p: [
                `Bu Gizlilik Politikası, ${COMPANY} web sitesi ve uygulamasını kullanan alıcı işletmeler, tedarikçiler ve ziyaretçiler için geçerlidir.`,
            ]},
            { h: "2. Toplanan Veriler", p: [
                "Hesap bilgileri (ad, e-posta, profil fotoğrafı — Google hesabınızdan), firma ve adres bilgileri, sipariş/teklif/mesajlaşma içerikleri, yüklediğiniz ürün görselleri ve platform kullanım verileri toplanmaktadır.",
            ]},
            { h: "3. Kullanım", p: [
                "Veriler; hizmetin sunulması, hesabınızın yönetimi, sipariş ve teslimat süreçlerinin yürütülmesi, bildirim gönderilmesi, platformun iyileştirilmesi ve yasal yükümlülüklerin yerine getirilmesi için kullanılır. Verileriniz üçüncü taraflara pazarlama amacıyla satılmaz.",
            ]},
            { h: "4. Güvenlik", p: [
                "Verileriniz şifreli bağlantı (HTTPS/TLS) üzerinden iletilir; erişim, rol bazlı yetkilendirme ile sınırlandırılır. API anahtarları ve gizli bilgiler ortam değişkenlerinde saklanır, kaynak koda yazılmaz. Oturum bilgileri güvenli çerezlerle (HttpOnly, Secure) yönetilir.",
            ]},
            { h: "5. Üçüncü Taraf Hizmetler", p: [
                "Platform; kimlik doğrulama (Google), yapay zekâ asistanı, görsel depolama ve sesli yanıt gibi hizmetler için güvenilir üçüncü taraf sağlayıcılar kullanır. Bu sağlayıcılarla yalnızca hizmetin gerektirdiği asgari veri paylaşılır.",
            ]},
            { h: "6. Değişiklikler", p: [
                `Bu politika güncellendiğinde sayfada yayınlanır. Sorularınız için: ${EMAIL}`,
            ]},
        ],
    },
    "cerez-politikasi": {
        title: "Çerez Politikası",
        updated: UPDATED,
        sections: [
            { h: "1. Çerez Nedir?", p: [
                "Çerezler, web sitesini ziyaretinizde tarayıcınıza kaydedilen küçük metin dosyalarıdır; sitenin düzgün çalışmasını ve deneyiminizin iyileştirilmesini sağlar.",
            ]},
            { h: "2. Kullandığımız Çerez Türleri", p: [
                "Zorunlu çerezler: oturum çerezi (session_token) — giriş yapmış kullanıcıyı tanır; HttpOnly ve Secure bayraklıdır.",
                "İşlevsel çerezler: tercihlerinizi (ör. karşılaştırma listesi) hatırlar.",
                "Performans/analitik çerezleri: site kullanımına dair anonim istatistikler toplanmasına yardımcı olur.",
            ]},
            { h: "3. Çerezlerin Yönetimi", p: [
                "Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz. Zorunlu çerezlerin engellenmesi durumunda giriş ve sepet gibi temel özellikler çalışmayabilir.",
            ]},
            { h: "4. Saklama", p: [
                "Oturum çerezleri 7 gün geçerlidir. Tercih verileri tarayıcınızda (localStorage) siz silene kadar saklanır.",
            ]},
        ],
    },
    "mesafeli-satis-sozlesmesi": {
        title: "Mesafeli Satış Sözleşmesi",
        updated: UPDATED,
        sections: [
            { h: "1. Taraflar", p: [
                `İşbu sözleşme; ${COMPANY} üzerinden ürün satan tedarikçi (\"SATICI\") ile platformda sipariş veren işletme (\"ALICI\") arasında, platformun aracılığıyla kurulmaktadır. Platform, 6563 sayılı Kanun kapsamında aracı hizmet sağlayıcıdır.`,
            ]},
            { h: "2. Konu", p: [
                "Sözleşmenin konusu; alıcının platform üzerinden elektronik ortamda sipariş verdiği ürünlerin satışı ve teslimine ilişkin tarafların hak ve yükümlülüklerinin belirlenmesidir.",
            ]},
            { h: "3. Sipariş ve Ödeme", p: [
                "Sipariş, alıcının sepeti onaylamasıyla oluşur ve tedarikçi onayıyla kesinleşir. Fiyatlar sipariş anında görüntülenen KDV dahil tutarlardır. Ödeme koşulları (peşin/vadeli) fatura üzerinde belirtilir.",
            ]},
            { h: "4. Teslimat", p: [
                "Ürünler, ürün sayfasında belirtilen teslim süresi içinde anlaşmalı kargo firmasıyla alıcının teslimat adresine gönderilir. Teslimat süreci platform üzerinden takip edilebilir.",
            ]},
            { h: "5. Cayma ve İade", p: [
                "Platform B2B (işletmeden işletmeye) satış modeliyle çalışmaktadır; 6502 sayılı Tüketici Kanunu'nun cayma hakkı hükümleri ticari alımlarda kural olarak uygulanmaz. İptal ve iade koşulları 'İptal ve İade Koşulları' sayfasında düzenlenmiştir.",
            ]},
            { h: "6. Uyuşmazlık", p: [
                "İşbu sözleşmeden doğan uyuşmazlıklarda Türkiye Cumhuriyeti yasaları uygulanır; Ankara mahkemeleri ve icra daireleri yetkilidir.",
            ]},
        ],
    },
    "on-bilgilendirme-formu": {
        title: "Ön Bilgilendirme Formu",
        updated: UPDATED,
        sections: [
            { h: "1. Satıcı ve Aracı Hizmet Sağlayıcı", p: [
                `Aracı hizmet sağlayıcı: ${COMPANY}, ${ADDRESS} — ${EMAIL}. Satıcı bilgileri her ürünün teklif/satın alma ekranında (tedarikçi adı, şehir, doğrulama durumu) gösterilir.`,
            ]},
            { h: "2. Ürün ve Fiyat Bilgileri", p: [
                "Ürünlerin temel nitelikleri, birim fiyatı (KDV hariç), kademeli fiyatları, minimum sipariş miktarı (MOQ) ve stok durumu ürün sayfasında yer alır. Ödenecek toplam tutar (KDV dahil) sepet ve sipariş onay ekranında gösterilir.",
            ]},
            { h: "3. Teslimat Bilgileri", p: [
                "Tahmini teslimat süresi ürün bazında (iş günü) ürün sayfasında belirtilir. Kargo firması ve takip numarası sipariş kargoya verildiğinde bildirilir.",
            ]},
            { h: "4. Cayma/İade Hakkına İlişkin Bilgilendirme", p: [
                "Platform ticari (B2B) alımlara yöneliktir. Sipariş iptali, tedarikçi hazırlamaya başlamadan önce panelden yapılabilir. İade koşulları için 'İptal ve İade Koşulları' sayfasına bakınız.",
            ]},
            { h: "5. Şikâyet ve İtiraz", p: [
                `Şikâyetlerinizi platform içi mesajlaşma, destek bildirimleri veya ${EMAIL} üzerinden iletebilirsiniz.`,
            ]},
        ],
    },
    "iptal-iade-kosullari": {
        title: "İptal ve İade Koşulları",
        updated: UPDATED,
        sections: [
            { h: "1. Sipariş İptali", p: [
                "Siparişiniz, tedarikçi tarafından 'Hazırlanıyor' aşamasına alınmadan önce (Bekliyor/Onaylandı durumundayken) Siparişler sayfasından tek tıkla iptal edilebilir. İptalde stoklar otomatik iade edilir ve fatura iptal edilir.",
            ]},
            { h: "2. İade Koşulları", p: [
                "Gıda ürünlerinde; ambalajı açılmamış, bozulmamış ve gıda güvenliğine uygun ürünler, teslim tarihinden itibaren 3 iş günü içinde iade talebine konu olabilir.",
                "Yanlış, eksik veya hasarlı ürün teslimatında, teslimat sırasında kargo görevlisine tutanak tutturulması ve platform üzerinden tedarikçiye mesaj iletilmesi gerekir.",
            ]},
            { h: "3. İade Süreci", p: [
                "İade talebi tedarikçi tarafından 2 iş günü içinde değerlendirilir. Onaylanan iadelerde ürünler anlaşmalı kargo ile alıcıdan alınır; ücret iadesi, ürünlerin tedarikçiye ulaşmasını takiben 7 iş günü içinde yapılır.",
            ]},
            { h: "4. İade Edilemeyen Ürünler", p: [
                "Ambalajı açılmış gıda ürünleri, son kullanma tarihi yaklaşmış ürünler ve alıcının deposunda uygun koşullarda saklanmamış ürünler iade kapsamı dışındadır.",
            ]},
        ],
    },
    "kullanim-kosullari": {
        title: "Kullanım Koşulları",
        updated: UPDATED,
        sections: [
            { h: "1. Genel", p: [
                `${COMPANY}; aktar, baharat, kuruyemiş, bakliyat ve gıda sektöründeki işletmeleri doğrulanmış tedarikçilerle buluşturan bir B2B satınalma platformudur. Platformu kullanarak bu koşulları kabul etmiş sayılırsınız.`,
            ]},
            { h: "2. Üyelik ve Hesap", p: [
                "Hesap bilgilerinizin doğruluğundan ve gizliliğinden siz sorumlusunuz. Platform, güvenlik veya mevzuat gerekçesiyle hesapları askıya alma/pasifleştirme hakkını saklı tutar.",
            ]},
            { h: "3. Tarafların Sorumlulukları", p: [
                "Tedarikçiler; ürün, fiyat, stok ve teslimat bilgilerinin doğruluğundan sorumludur. Alıcılar; sipariş ve ödeme yükümlülüklerinden sorumludur. Platform, taraflar arasındaki sözleşmenin tarafı değildir ancak sürecin güvenli yürütülmesi için aracılık eder.",
            ]},
            { h: "4. Fikri Mülkiyet", p: [
                "Platformun tasarımı, logosu, yazılımı ve içerik düzeni platforma aittir. Tedarikçilerin yüklediği ürün görselleri ve açıklamaları ilgili tedarikçiye aittir; tedarikçi bu içeriklerin haklarına sahip olduğunu beyan eder.",
            ]},
            { h: "5. Yasaklı Kullanım", p: [
                "Platformun kötüye kullanılması, sahte sipariş/başvuru oluşturulması, diğer kullanıcıların verilerine yetkisiz erişim girişimi ve mevzuata aykırı ürün listelenmesi yasaktır.",
            ]},
            { h: "6. Değişiklikler", p: [
                "Platform bu koşulları güncelleyebilir; güncel metin bu sayfada yayınlanır ve yayın tarihinde yürürlüğe girer.",
            ]},
        ],
    },
    "kargo-teslimat": {
        title: "Kargo ve Teslimat",
        updated: UPDATED,
        sections: [
            { h: "1. Teslimat Süreleri", p: [
                "Her ürün için tahmini teslimat süresi (1-5 iş günü) ürün sayfasında tedarikçi bazında gösterilir. Sipariş tedarikçi tarafından hazırlandıktan sonra anlaşmalı kargoya (Yurtiçi, MNG, Aras, Sürat) teslim edilir.",
            ]},
            { h: "2. Teslimat Bölgeleri", p: [
                "Tedarikçilerin hizmet bölgeleri tedarikçi profillerinde belirtilir; birçok tedarikçi Türkiye geneline gönderim yapar.",
            ]},
            { h: "3. Sevkiyat Takibi", p: [
                "Sipariş kargoya verildiğinde bildirim alırsınız; Sevkiyat sayfasından kargo firması, takip numarası ve tahmini teslim tarihini takip edebilirsiniz. Teslim aldığınızda 'Teslim Aldım' onayı vermeniz süreci tamamlar.",
            ]},
            { h: "4. Hasarlı/Eksik Teslimat", p: [
                "Hasarlı veya eksik gelen ürünlerde kargo görevlisine tutanak tutturun ve 24 saat içinde platform üzerinden tedarikçiye mesaj gönderin. Tutanaklı başvurular öncelikli işleme alınır.",
            ]},
            { h: "5. Kargo Ücreti", p: [
                "Kargo ücreti uygulaması tedarikçi bazlıdır; birçok tedarikçi minimum sipariş tutarı üzerindeki siparişlerde kargoyu karşılar. Sepette tedarikçi bazında kargo barajı ilerlemesi gösterilir.",
            ]},
        ],
    },
};
